// eslint-disable-next-line
import { injectable } from "inversify";
import { IFollowUpQuestion, IPolicyRule, IReasonDeleteResponse, IReturnReason } from "../../models/ReturnReasonTypes";
import {IReorderedItem, WithOld} from "../../stores/types";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";

export interface IReturnReasonsService {
    getReturnReasonsList: () => Promise<IReturnReasonData>,
}

interface IReturnReasonData {
    return_reasons: IReturnReason[],
    settings: IReturnReasonsSettings,
}

interface IMCFReturnReason {
    value: string,
    label: string,
    description: string,
}


export interface IReturnReasonsSettings {
    mcf_return_reasons: IMCFReturnReason[],
}


@injectable()
class ReturnReasonsService implements IReturnReasonsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async getReturnReasonsList(): Promise<IReturnReasonData> {
        const res = await this.httpService.get<IApiResponse<IReturnReasonData>>(`/rms-api/return-reasons`);
        return res.payload;
    };

    async saveNewWeights(reasons: IReorderedItem[]) {
        const res = await this.httpService.put<IApiResponse<IReturnReason>>(`/rms-api/return-reasons/reorder`, reasons);
        return res.payload;
    }

    async updateReason(reasonId:number, reason: WithOld<IReturnReason>): Promise<IReturnReason> {
        const res = await this.httpService.put<IApiResponse<IReturnReason>>(`/rms-api/return-reasons/${reasonId}`, reason);
        return res.payload;
    }

    async createReason(reason: IReturnReason): Promise<IReturnReason> {
        const res = await this.httpService.post<IApiResponse<IReturnReason>>(`/rms-api/return-reasons`, reason);
        return res.payload;
    }

    async deleteReason(reasonId:number): Promise<IPolicyRule[]> {
        const res = await this.httpService.remove<IApiResponse<IReasonDeleteResponse>>(`/rms-api/return-reasons/${reasonId}`);
        return res.payload.rules_using_reason;
    }

    async updateQuestion(reasonId:number|string, questionId:number, question: WithOld<IFollowUpQuestion>): Promise<IFollowUpQuestion> {
        const res = await this.httpService.put<IApiResponse<IFollowUpQuestion>>(`/rms-api/return-reasons/${reasonId}/${questionId}`, question);
        return res.payload;
    }

    async createQuestion(reasonId:number|string, question: IFollowUpQuestion): Promise<IFollowUpQuestion> {
        const res = await this.httpService.post<IApiResponse<IFollowUpQuestion>>(`/rms-api/return-reasons/${reasonId}/question-create`, question);
        return res.payload;
    }

    /** used for debug, not functional */
    async getPortalReturnReasonsList(): Promise<IReturnReason[]> {
        const res = await this.httpService.get<IReturnReason[]>(`/rms-api/portal-return-reasons`);
        return res;
    };

}

export default ReturnReasonsService;
